import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Text } from 'bold-ui'
import { FormSectionAccordion } from 'components/accordion/FormSectionAccordion'
import { CheckboxField } from 'components/form'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { RequisicaoExameMamografiaFormValues } from '../model-mamografia'

const meta = metaPath<RequisicaoExameMamografiaFormValues>()

type MamografiaIndicacaoClinicaAccordionOption = {
  name: string
  label: string
}

export interface MamografiaIndicacaoClinicaAccordionProps {
  uuid: string
  title: string
  options: MamografiaIndicacaoClinicaAccordionOption[]
}

export function MamografiaIndicacaoClinicaAccordion(props: Readonly<MamografiaIndicacaoClinicaAccordionProps>) {
  const { options, title, uuid } = props

  const styles = createStyles()

  return (
    <FormSectionAccordion name={meta.openedAccordions} title={title} uuid={uuid} style={styles.accordion}>
      <Table style={styles.table}>
        <TableHead>
          <TableRow>
            <TableHeader style={styles.header}>Achado</TableHeader>
            <TableHeader style={styles.header}>Direita</TableHeader>
            <TableHeader style={styles.header}>Esquerda</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {options.map(({ label, name }) => (
            <TableRow key={label}>
              <TableCell style={styles.cell}>
                <Text>{label}</Text>
              </TableCell>
              <TableCell style={styles.cell}>
                <CheckboxField name={name} value={RastreioCancerPerguntaOpcaoEnum.DIREITA} />
              </TableCell>
              <TableCell style={styles.cell}>
                <CheckboxField name={name} value={RastreioCancerPerguntaOpcaoEnum.ESQUERDA} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </FormSectionAccordion>
  )
}

const createStyles = () => ({
  accordion: {
    marginTop: '0.25rem',
    marginBottom: '0.25rem',
  },
  table: {
    padding: '1rem',
    border: 'none',
  },
  header: {
    width: '33.33%',
  },
  cell: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
})
